var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mp-table-body',_vm._l((_vm.rows),function(n){return _c('mp-table-row',{key:n},_vm._l((_vm.columns),function(m){return _c('mp-table-cell',{key:m,attrs:{"as":"td","scope":"row"}},[_c('mp-skeleton',{attrs:{"variant-color":"gray","width":"inherit","height":"20px","rounded":"full"}})],1)}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }